export const matchHead = (head, string) => {
  return (new RegExp(head, 'gi')).test(string);
}